<template lang="pug">
  .row(v-if='isTrial')
    .relative.m4-right-3(:class='{ "trial-team-icon m4-right-10" : team }')
      simple-svg.dark-gray-icon(
        :filepath='lockIcon'
        :width='"20px"'
        :height='"20px"'
      )
    span.dark-gray.text-big(:class='{ "text-normal" : team }')
      | {{ infoText }}
  div(v-else)
    slot
</template>

<script>
import lockIcon from '@/assets/ic_lock.svg'

import userRole from '../../mixins/userRole'

export default {
  mixins: [userRole],
  data() {
    return {
      lockIcon
    }
  },
  computed: {
    infoText() {
      return this.team ? this.$t(`trial.${this.team}Label`) : this.$t('trial.disabledOnTrial')
    }
  },
  props: {
    team: { type: String, required: false }
  }
}
</script>

<style lang="scss">
@import 'src/scss/variables/colors';

.trial-team-icon::before {
  content: '';
  border-radius: 50%;
  border: 1px solid $dark-gray;
  border-style: dashed;
  position: absolute;
  height: 54px;
  width: 54px;
  left: -19px;
  top: -17px;
}
</style>
